module.exports = __webpack_public_path__ + "img/banner-step1.d511ee22.png";